<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header color="accent" class="white--text">
        CSV Preview
        <template #actions>
          <v-icon color="white">$expand</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-data-table :headers="headers" :items="rows" :items-per-page="5" class="pt-4 csv-table" fixed-header dense />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'CsvTable',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      if (!this.rows.length) return []
      const [row] = this.rows
      return Object.keys(row).map(value => ({ text: value, value, cellClass: 'table-cell-nowrap', sortable: false }))
    },
  },
}
</script>

<style lang="scss" scoped>
.csv-table ::v-deep .table-cell-nowrap {
  max-width: 240px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
